export const createGzip = () => ({
  pipe() {
    return this;
  },
});

export const createZstdCompress = () => ({
  pipe() {
    return this;
  },
});

export default { createGzip, createZstdCompress };
